import { PropsWithChildren } from 'react'
import {
  PurchaseStateIcon,
  PurchaseStateBody,
  PurchaseStateTitle,
  PurchaseStateWrapper,
} from '../styles'

interface PurchaseStateProps {
  icon: string
  iconColor: string
  title: string
}

function PurchaseState({
  icon,
  title,
  iconColor,
  children,
}: PropsWithChildren<PurchaseStateProps>) {
  return (
    <PurchaseStateWrapper>
      <PurchaseStateIcon path={icon} size={3} color={iconColor} />
      <PurchaseStateTitle>{title}</PurchaseStateTitle>
      <PurchaseStateBody>{children}</PurchaseStateBody>
    </PurchaseStateWrapper>
  )
}

export default PurchaseState
